exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin-toggle[data-v-fda68eb0] {\n  top: 1rem;\n  right: 1rem;\n  position: absolute;\n}\n.admin-menu[data-v-fda68eb0] {\n  display: flex;\n  text-align: center;\n  justify-content: space-between;\n  margin: -1.25rem 0 2.75rem;\n  border-bottom: 1px dashed;\n}\n.admin-menu-item.active .admin-menu-link[data-v-fda68eb0] {\n  color: var(--info);\n}\n.admin-menu-link[data-v-fda68eb0] {\n  display: inline-block;\n  padding: 0.25rem 1rem;\n}", ""]);

// exports
